<template>
    <div class="nav">
       <a href="http://www.cebpubservice.com/" target="_blank">返回首页</a><span style="color: #9e9e9e;">&nbsp;&nbsp;|&nbsp;&nbsp;</span><a href="http://www.cebpubservice.com/low/us/index.shtml?20151216153242" target="_blank">联系我们</a>
    </div>
</template>

<script>
import { logout } from '@/api/api.js'
import Cookies from 'js-cookie'
export default {
    name: 'navbar',
    props: {
      
    },
    data() {
        return {
          
        }
    },
    methods: {
      
    },
    mounted() {
  
    },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear::after {
    height: 0;
    clear: both;
    content: "";
    display: block;
    visibility: hidden;
}

.clear {
    /*ie6清除浮动的方式 *号只有IE6-IE7执行，其他浏览器不执行*/
    *zoom: 1;
}

.nav {
    height: 70px;
    line-height: 70px;
    text-align: right;
    width: 1000px;
    margin: 0 auto;
}

.nav a {
    /* color:#101010; */
    font-size: 15px;
    text-decoration: none;
    color: #9e9e9e;
    outline: none;
}

</style>
